// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"39a7ba33","60":"a684ffa9","68":"008e97ea","72":"b819b20c","112":"2960958f","120":"3c18e034","132":"32880513","292":"ea145ff8","344":"119f2cad","448":"55e6a573","453":"236d1c5f","633":"4526f456","739":"88505b1d","752":"576f92d6","788":"fa6e3b63","944":"e4547d55"}[chunkId] + ".chunk.js";
};